import React, { FC } from "react";
import { all_routes } from "../../../router/all_routes";
import { Link } from "react-router-dom";

type Props = {
  data?: any;
  onClick?: any;
};

const StudentBreadcrumb: FC<Props> = (props) => {
  const { data, onClick } = props;
  const routes = all_routes;
  return (
    <div className="col-md-12">
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <div className="my-auto mb-2">
          <h3 className="page-title mb-1">Registrations</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={routes.studentList}>Registrations</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Registration Form Details
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <button className="btn btn-light me-2 mb-2" onClick={onClick}>
            <i className="ti ti-printer" />
            Print Admit Card
          </button>

          <Link
            to={routes.addRegistrationForm}
            state={data}
            className="btn btn-primary d-flex align-items-center mb-2"
          >
            <i className="ti ti-edit-circle me-2" />
            Edit Registration
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StudentBreadcrumb;
